import {
  GET_FILES,
  ERROR_FILES,
  DELETE_FILE,
  POST_FILE,
  PUT_FILE
} from "../actions/types"

const initialState = {
  mediasList: null,
  error: null,
};

export default function companiesReducer(state = initialState, action) {
  switch (action.type) {
    case POST_FILE: {
      const added = Array.isArray(action.payload) ? action.payload : [action.payload];
      return {
        ...state,
        mediasList: state.mediasList ? state.mediasList.concat(added) : added
      };
    }
    case PUT_FILE: {
      if (!state.mediasList) {
        return state;
      }
      const list = [...state.mediasList];
      const index = list.findIndex(m => m._id === action.payload._id);
      if (index >= 0) {
        list[index] = action.payload;
      }
      return {...state , mediasList: list};
    }
    case DELETE_FILE:
      return {
        ...state,
        mediasList: state.mediasList
          ? state.mediasList.filter(item => item._id !== action.payload)
          : null
      };
    case GET_FILES:
      return {...state , mediasList: action.payload}
    case ERROR_FILES:
      return {...state , error: action.payload}
    default:
      return {...state};
  }
}